import { ITicket } from '@@sapporo/ticket/interface/ITicket';
import { formatBadgesInfo } from '@/utils/domain/leisure';
import clsx from 'clsx';
import React from 'react';

import styles from './LeisureCommonBadges.module.scss';
import { ITicketV3 } from '@/models/Leisure/interfaces/payloads/ILeisureProductsPayload';

interface ILeisureCommonBadgesProps {
  item: ITicket | ITicketV3;
  className?: string;
}

const LeisureCommonBadges: React.FC<ILeisureCommonBadgesProps> = ({ className, item }) => {
  const badgesInfo = formatBadgesInfo(item);

  return (
    <div className={clsx(styles.container, className)}>
      {badgesInfo.hotDeal && <span className={styles.hotdeal}>{badgesInfo.hotDeal}</span>}
      {badgesInfo.todayUse && <span className={styles.badge}>{badgesInfo.todayUse}</span>}
      {badgesInfo.fullRefund && <span className={styles.badge}>{badgesInfo.fullRefund}</span>}
    </div>
  );
};

export default LeisureCommonBadges;
